import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
// import moment from 'moment';
import {
  Drawer,
  Form,
  Button,
  Row,
  Col,
  Divider,
  Typography,
  DatePicker,
  Select,
  Input,
  Spin,
} from "antd";
import {
  DownloadOutlined,
  PlusCircleFilled,
  EditFilled,
  DeleteFilled,
} from "@ant-design/icons";
import debounce from "lodash/debounce";
import useAxios from "./../../../CustomHooks/useAxios";

import ShowAgentsTable from "./ShowAgentsTable";
import PageLink from "./../../PageLink/PageLink";
import AddAgents from "./AddAgents";

import AddAgentsRange from "./AddAgentsRange";

import EditAgentsRange from "./EditAgentsRange";
const { Text } = Typography;
const { Option } = Select;
const dateFormat = "YYYY-MM-DD";
function DebounceSelect({ fetchOptions, debounceTimeout = 350, ...props }) {
  const [fetching, setFetching] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const fetchRef = React.useRef(0);

  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;
      setOptions([]);
      setFetching(true);
      fetchOptions(value).then((newOptions) => {
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return;
        }

        setOptions(newOptions);
        setFetching(false);
      });
    };

    return debounce(loadOptions, debounceTimeout);
  }, [fetchOptions, debounceTimeout]);
  return (
    <Select
      allowClear
      labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={fetching ? <Spin size="small" /> : null}
      {...props}
      options={options}
    />
  );
} // Usage of DebounceSelect

export default function Agents() {
  let { page } = useParams();
  const { axiosi } = useAxios();

  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleAddRange, setVisibleAddRange] = useState(false);
  const [visibleEditRange, setVisibleEditRange] = useState(false);
  const [data, setData] = useState();
  const [refresh, setRefresh] = useState(false);

  const [companyid, setCompanyid] = React.useState();
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [endpoint_id, setEndpoint_id] = useState("");
  const [refreshSearch, setRefreshSearch] = useState(true);
  // <-- THÊM MỚI: Quản lý phiên bản để bust cache avatar trong bảng
  const [tableVersion, setTableVersion] = useState(Date.now());
  const hideItem = useSelector((state) => state.loginReducer.hideItem);
  const user = useSelector((state) => state.loginReducer.user);

  const [selectedDepartments, setSelectedDepartments] = useState([]);
  const [selectedAgencies, setSelectedAgencies] = useState([]);
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(undefined);
  const [selectedAuthorizationGroups, setSelectedAuthorizationGroups] = useState([]);

  const [departments, setDepartments] = useState([]);
  const [agencies, setAgencies] = useState([]);
  const [teams, setTeams] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [authorizationGroups, setAuthorizationGroups] = useState([]);

  useEffect(() => {
    const fetchAuthorizationGroups = async () => {
      try {
        const kq = await axiosi.get("authorization_groups", { params: { pageSize: 200 } });
        setAuthorizationGroups(kq.data?.rows || []);
      } catch (err) {
        console.error("Error fetching authorization groups:", err);
      }
    };
    fetchAuthorizationGroups();
  }, []);

  const isInitialized = React.useRef(false);

  useEffect(() => {
    if (user?.agents?.[0] && !isInitialized.current) {
      setCompanyid({ value: user.agents[0].company_id, label: user.agents[0].gmcomname });
      isInitialized.current = true;
    }
  }, [user?.agents]);

  useEffect(() => {
    const fetchFilterOptions = async () => {
      if (!companyid?.value) {
        setDepartments([]);
        setAgencies([]);
        setTeams([]);
        setCampaigns([]);
        return;
      }
      try {
        const [depKq, agencyKq, teamKq, campaignKq] = await Promise.all([
          axiosi.get("department", { params: { company_id: companyid.value, pageSize: 500 } }),
          axiosi.get("agencies", { params: { company_id: companyid.value, pageSize: 500 } }),
          axiosi.get("agent_teams", { params: { company_id: companyid.value, pageSize: 500 } }),
          axiosi.get("campaigns", { params: { company_id: companyid.value, pageSize: 500 } }),
        ]);

        setDepartments(depKq.data?.rows || []);
        setAgencies(agencyKq.data?.rows || []);
        setTeams(teamKq.data?.rows || []);
        setCampaigns(campaignKq.data?.rows || []);
      } catch (err) {
        console.error("Error fetching filter options:", err);
      }
    };

    fetchFilterOptions();
  }, [companyid?.value]);

  const handleCompanyChange = (newValue) => {
    setCompanyid(newValue);
    setSelectedDepartments([]);
    setSelectedAgencies([]);
    setSelectedTeams([]);
    setSelectedCampaigns([]);
  };

  useEffect(() => {
    doSearch();
  }, [refreshSearch, page]);
  async function fetchUserList(company_name) {
    console.log("fetching user", company_name);
    const body = await axiosi.get("companies", {
      params: { company_name, pageSize: 100 },
    });
    if (body?.data?.rows) {
      return body?.data?.rows.map((user) => ({
        label: user.company_name,
        value: user.id,
      }));
    } else {
      const a = [{ label: "---no data---", value: "" }];
      return a.map((i) => i);
    }
    // return axiosi.get('companies',{params:{company_name,pageSize:100}} ) // fetch('https://randomuser.me/api/?results=5')
    //   .then((body) =>
    //     body?.data?.rows.map((user) => ({
    //      label: user.company_name,
    //       value: user.id,
    //     })),
    //   );
  }
  const handleAddRange = () => {
    console.log("[handleAddRange]:");
    setVisibleAddRange(true);
  };

  const handleEditRange = () => {
    console.log("[handleEditRange]:");
    setVisibleEditRange(true);
  };
  const onCloseAddRange = () => {
    setVisibleAddRange(false);
  };
  const onCloseEditRange = () => {
    setVisibleEditRange(false);
  };
  const handleAdd = () => {
    console.log("[handleAdd]:");
    setVisibleAdd(true);
  };
  const onCloseAdd = () => {
    setVisibleAdd(false);
  };
  const handleSearch = async () => {
    // console.log("[search]");
    try {
      const kq = await axiosi.get("agents", {
        params: {
          name,
          username,
          company_id: companyid?.value,
          endpoint_id,
          department_ids: selectedDepartments.join(","),
          agency_ids: selectedAgencies.join(","),
          team_ids: selectedTeams.join(","),
          campaign_ids: selectedCampaigns.join(","),
          authorization_group_ids: selectedAuthorizationGroups.join(","),
          activestatus: selectedStatus !== undefined ? selectedStatus : "",
        },
      });
      console.log("[handleSearch]:kq.data=", kq.data);
      setData(kq.data);
      setTableVersion(Date.now()); // <-- THÊM DÒNG NÀY
    } catch (err) {
      console.log("ERROR");
    }
  };

  const handleSearchExport = async () => {
    console.log("[search]");
    try {
      const sdata = {
        pageSize: 2000,
        name,
        username,
        company_id: companyid?.value,
        endpoint_id,
        department_ids: selectedDepartments.join(","),
        agency_ids: selectedAgencies.join(","),
        team_ids: selectedTeams.join(","),
        campaign_ids: selectedCampaigns.join(","),
        authorization_group_ids: selectedAuthorizationGroups.join(","),
        activestatus: selectedStatus !== undefined ? selectedStatus : "",
      };
      // const kq=await axiosi.get('agents',{params:{name,username,company_id:companyid?.value,endpoint_id}});
      const kq = await axiosi.get("agents/exportAgentToFile", {
        params: sdata,
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([kq.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `exportAgents.xlsx`); //or any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();

      // console.log("[handleSearch]:kq.data=",kq.data);
      // setData(kq.data);
    } catch (err) {
      console.log("ERROR");
    }
  };
  const doSearch = async () => {
    console.log("[search]");
    try {
      const kq = await axiosi.get("agents", {
        params: {
          page,
          pageSize: 20,
          name,
          username,
          company_id: companyid?.value,
          endpoint_id,
          department_ids: selectedDepartments.join(","),
          agency_ids: selectedAgencies.join(","),
          team_ids: selectedTeams.join(","),
          campaign_ids: selectedCampaigns.join(","),
          authorization_group_ids: selectedAuthorizationGroups.join(","),
          activestatus: selectedStatus !== undefined ? selectedStatus : "",
        },
      });
      console.log("[handleSearch]:kq.data=", kq.data);
      setData(kq.data);
      setTableVersion(Date.now()); // <-- THÊM DÒNG NÀY
    } catch (err) {
      console.log("ERROR");
    }
  };
  return (
    <>
      <Drawer
        title="Add"
        placement="right"
        onClose={onCloseAdd}
        visible={visibleAdd}
      >
        <AddAgents
          setVisibleAdd={setVisibleAdd}
          setRefreshSearch={setRefreshSearch}
        />
      </Drawer>
      <Drawer
        title="Add"
        width={450}
        placement="right"
        onClose={onCloseAddRange}
        visible={visibleAddRange}
      >
        <AddAgentsRange
          setVisibleAdd={setVisibleAddRange}
          setRefreshSearch={setRefreshSearch}
        />
      </Drawer>
      <Drawer
        title="Edit"
        width={450}
        placement="right"
        onClose={onCloseEditRange}
        visible={visibleEditRange}
      >
        <EditAgentsRange
          setVisible={setVisibleEditRange}
          setRefreshSearch={setRefreshSearch}
        />
      </Drawer>

      <section className="search">
        <div className="container">
          <div className="row searchbox">
            {/* <div > */}
            <div className="right">Search:</div>
            {/* <Typography.Title  level={3}>Search :
                </Typography.Title> */}
            {/* </div> */}
            <div className="left">
              <Button
                onClick={handleAdd}
                icon={<PlusCircleFilled style={{ color: "#1890ff" }} />}
              >
                Add
              </Button>
              <Button
                onClick={handleAddRange}
                icon={<PlusCircleFilled style={{ color: "#1890ff" }} />}
              >
                Add Range
              </Button>
              <Button
                onClick={handleEditRange}
                icon={<EditFilled style={{ color: "#1890ff" }} />}
              >
                Edit Range
              </Button>
            </div>
          </div>
          {/* <div className='doubleline'></div> */}

          <div className="row" style={{ flexWrap: "wrap", padding: "0.5rem 0", gap: "10px 0" }}>
            <div className={hideItem} style={{ minWidth: "180px", flex: 1, marginRight: "10px" }}>
              <label>Company :</label>
              <DebounceSelect
                showSearch={true}
                value={companyid}
                placeholder="Select a company !"
                fetchOptions={fetchUserList}
                onChange={handleCompanyChange}
                style={{ width: "100%" }}
              />
            </div>
            <div className="col" style={{ minWidth: "180px", flex: 1, marginRight: "10px" }}>
              <label>Agent name :</label>
              <Input onChange={({ target: { value } }) => setName(value)} />
            </div>
            <div className="col" style={{ minWidth: "180px", flex: 1, marginRight: "10px" }}>
              <label>User name :</label>
              <Input onChange={({ target: { value } }) => setUsername(value)} />
            </div>
            <div className="col" style={{ minWidth: "180px", flex: 1, marginRight: "10px" }}>
              <label>Exten :</label>
              <Input
                onChange={({ target: { value } }) => setEndpoint_id(value)}
              />
            </div>
          </div>

          <div className="row" style={{ flexWrap: "wrap", padding: "0.5rem 0", gap: "10px 0" }}>
            <div className="col" style={{ minWidth: "180px", flex: 1, marginRight: "10px" }}>
              <label>Department :</label>
              <Select
                mode="multiple"
                allowClear
                showSearch
                optionFilterProp="label"
                style={{ width: "100%" }}
                placeholder="Select departments"
                value={selectedDepartments}
                onChange={setSelectedDepartments}
                options={departments.map((d) => ({ label: d.name, value: d.id }))}
              />
            </div>
            <div className="col" style={{ minWidth: "180px", flex: 1, marginRight: "10px" }}>
              <label>Agency :</label>
              <Select
                mode="multiple"
                allowClear
                showSearch
                optionFilterProp="label"
                style={{ width: "100%" }}
                placeholder="Select agencies"
                value={selectedAgencies}
                onChange={setSelectedAgencies}
                options={agencies.map((a) => ({ label: a.name, value: a.id }))}
              />
            </div>
            <div className="col" style={{ minWidth: "180px", flex: 1, marginRight: "10px" }}>
              <label>Team :</label>
              <Select
                mode="multiple"
                allowClear
                showSearch
                optionFilterProp="label"
                style={{ width: "100%" }}
                placeholder="Select teams"
                value={selectedTeams}
                onChange={setSelectedTeams}
                options={teams.map((t) => ({ label: t.name, value: t.id }))}
              />
            </div>
            <div className="col" style={{ minWidth: "180px", flex: 1, marginRight: "10px" }}>
              <label>Campaign :</label>
              <Select
                mode="multiple"
                allowClear
                showSearch
                optionFilterProp="label"
                style={{ width: "100%" }}
                placeholder="Select campaigns"
                value={selectedCampaigns}
                onChange={setSelectedCampaigns}
                options={campaigns.map((c) => ({ label: c.name_year || c.name, value: c.id }))}
              />
            </div>
            <div className="col" style={{ minWidth: "180px", flex: 1, marginRight: "10px" }}>
              <label>Author group (Role) :</label>
              <Select
                mode="multiple"
                allowClear
                showSearch
                optionFilterProp="label"
                style={{ width: "100%" }}
                placeholder="Select roles"
                value={selectedAuthorizationGroups}
                onChange={setSelectedAuthorizationGroups}
                options={authorizationGroups.map((g) => ({ label: g.name, value: g.id }))}
              />
            </div>
            <div className="col" style={{ minWidth: "150px", flex: 1, marginRight: "10px" }}>
              <label>Active Status :</label>
              <Select
                allowClear
                style={{ width: "100%" }}
                placeholder="Select status"
                value={selectedStatus}
                onChange={setSelectedStatus}
              >
                <Option value={1}>Active</Option>
                <Option value={0}>DeActivate</Option>
              </Select>
            </div>
          </div>

          <div className="row" style={{ padding: "0.5rem 0" }}>
            <div className="col" style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
              <Button type="primary" onClick={handleSearch} style={{ width: "120px" }}>Search</Button>
              <Button onClick={handleSearchExport} style={{ width: "120px" }}>Export</Button>
            </div>
          </div>
        </div>
      </section>
      <section className="searchResult">
        <div className="row">
          <Typography.Title level={3}>Result:</Typography.Title>
        </div>
        <div className="row">
          {data?.rows && (
            <ShowAgentsTable
              data={data.rows}
              setRefreshSearch={setRefreshSearch}
              tableVersion={tableVersion}
            />
          )}
        </div>
        <div className="row">
          {data?.pages > 1 ? (
            <PageLink
              pageSize={data.pageSize}
              searchpage={"agents"}
              pages={data.pages}
              numrows={data.numrows}
              page={data.page}
            />
          ) : (
            <h1>chi co' 1 page</h1>
          )}
        </div>
      </section>
    </>
  );
}
